export enum FeatureName {
  FastAccess = 'FastAccess',
  SmsNotifications = 'SmsNotifications',
  CA3000 = 'CA3000',
  CA4K = 'CA4K',
  EIQIntelliTicket = 'EIQIntelliTicket',
  EIQViolation = 'EIQViolation',
  CA3000Expirations = 'CA3000Expirations',
  NorthStar = 'NorthStar',
  ConnectEditPin = 'ConnectEditPin',
  GuestLimitations = 'GuestLimitations',
  BasIP = 'BasIP',
  EIQProfile = 'EIQProfile',
  ConnectFID = 'ConnectFID',
}
